<template>
  <section class="Carousel">
    <Slick
      ref="slick"
      :options="slickOptions"
      @afterChange="handleAfterChange"
      @beforeChange="handleBeforeChange"
      @breakpoint="handleBreakpoint"
      @destroy="handleDestroy"
      @edge="handleEdge"
      @init="handleInit"
      @reInit="handleReInit"
      @setPosition="handleSetPosition"
      @swipe="handleSwipe"
      @lazyLoaded="handleLazyLoaded"
      @lazyLoadError="handleLazeLoadError"
      v-if="carousel.length > 0"
    >
      <div class="item" v-for="item in carousel">
        <div v-if="!item.video">
          <img
            class="images-carousel"
            v-if="!mobile"
            :src="item.bg_image"
            :alt="item.title"
          />
          <img
            class="images-carousel"
            v-if="mobile"
            :src="item.bg_resp_image"
            :alt="item.title"
            height="100%"
          />
        </div>
        <div v-else>
          <video class="container-video" preload="auto">
            <source
              class="source-video"
              v-bind:src="item.video"
              type="video/mp4"
              media="all and (max-width:1920px)"
              style="height: 100%"
            />
          </video>
        </div>
        <article class="box">
          <div class="container-box">
            <h3 class="title">{{ item.category }}</h3>
            <h2 class="title-description">{{ item.title }}</h2>
            <p class="description" v-html="item.content">{{ item.content }}</p>
            <router-link class="btn" :to="{ name: item.link }">{{
              $t("home.leia-mais")
            }}</router-link>
          </div>
        </article>
      </div>
    </Slick>
  </section>
</template>

<script>
import Slick from "vue-slick";
export default {
  components: {
    Slick
  },
  props: ["carousel", "mobile"],

  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        infinity: true,
        speed: 1000,
        autoplaySpeed: 5000
      }
    };
  },

  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    // Events listeners
    handleAfterChange(event, slick, currentSlide) {
      let slickElement = document.getElementsByClassName("slick-slide")[
        currentSlide + 1
      ];
      let video = slickElement.querySelector(".container-video");

      if (slickElement.querySelector(".container-video") === null) {
        for (
          let a = 0;
          a <= document.getElementsByClassName("container-video").length - 1;
          a++
        ) {
          document.getElementsByClassName("container-video")[a].pause();
        }
      } else {
        video.play();
      }
      // document.getElementsByTagName("video")[currentSlide]
    },
    handleBeforeChange(event, slick, currentSlide, nextSlide) {
      // console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
    },
    handleBreakpoint(event, slick, breakpoint) {
      // console.log('handleBreakpoint', event, slick, breakpoint);
    },
    handleDestroy(event, slick) {
      // console.log('handleDestroy', event, slick);
    },
    handleEdge(event, slick, direction) {
      // console.log('handleEdge', event, slick, direction);
    },
    handleInit(event, slick) {
      let videos = document.getElementsByClassName("container-video");

      let images = document.getElementsByClassName("images-carousel");
      let heightImages = images[0].offsetHeight + "px";

      for (let a = 0; a <= videos.length - 1; a++) {
        videos[a].style.height = heightImages;
      }
    },
    handleReInit(event, slick) {
      // console.log('handleReInit', event, slick);
    },
    handleSetPosition(event, slick) {
      // console.log('handleSetPosition', event, slick);
    },
    handleSwipe(event, slick, direction) {
      // console.log('handleSwipe', event, slick, direction);
    },
    handleLazyLoaded(event, slick, image, imageSource) {
      // console.log('handleLazyLoaded', event, slick, image, imageSource);
    },
    handleLazeLoadError(event, slick, image, imageSource) {
      // console.log('handleLazeLoadError', event, slick, image, imageSource);
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/slick/slick";
@import "../../../assets/slick/slick-theme";

.Carousel {
  position: relative;
  z-index: 1;
  max-height: 600px;
  overflow: hidden;

  .slick-dots {
    position: absolute;
    bottom: 35px;
    text-align: center;
    z-index: 10;

    li {
      width: 18px;
      height: 18px;
      overflow: hidden;
      transition: all linear 0.1s;
      box-sizing: border-box;
      padding: 4px;

      button {
        display: block;
        overflow: hidden;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 2px solid transparent;
        background-color: #fff;
        transition: all linear 0.1s;
        padding: 0px;

        &:before {
          display: none;
        }
      }

      &.slick-active {
        padding: 0px;
        button {
          background-color: transparent;
          border-color: #fff;
        }
      }
    }
  }

  .item {
    position: relative;

    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      max-height: 600px;
    }
  }

  .box {
    position: absolute;
    top: 0;
    left: 60px;
    z-index: 10;
    width: 380px;
    color: #fff;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    align-items: center;

    .title {
      font-size: 1.8em;
      text-transform: uppercase;
      font-weight: 200;
      margin-bottom: 20px;
    }
    .title-description {
      max-width: 80vw;
      font-size: 4.6em;
      line-height: 46px;
      margin-bottom: 25px;
    }

    .description {
      font-style: italic;
      font-size: 2em;
      margin-bottom: 30px;
    }

    .btn {
      width: 170px;
      height: 50px;
      line-height: 46px;
      display: inline-block;
      text-align: center;
      color: #3ab8e8;
      border: 2px solid #3ab8e8;
      text-transform: uppercase;
      font-size: 2em;
    }
  }
}

@media (max-width: 1024px) {
  .Carousel {
    .box {
      .title {
        font-size: 1.4em;
      }

      .title-description {
        font-size: 4em;
      }

      .description {
        font-size: 1.6em;
      }

      .btn {
        width: 160px;
        height: 40px;
        line-height: 35px;
        font-size: 1.8em;
      }
    }
  }

  .slick-dotted.slick-slider {
    margin-bottom: 0;
  }
}

@media (max-width: 768px) {
  .Carousel {
    video {
      left: -50%;
    }

    .box {
      .title {
        font-size: 1.4em;
        margin-bottom: 15px;
      }

      .title-description {
        font-size: 3em;
        margin-bottom: 15px;
      }

      .description {
        font-size: 1.6em;
        margin-bottom: 25px;
      }

      .btn {
        width: 160px;
        height: 40px;
        line-height: 35px;
        font-size: 1.8em;
      }
    }
  }

  .slick-dotted.slick-slider {
    margin-bottom: 0;
  }
}

@media (max-width: 640px) {
  .Carousel {
    .box {
      left: 40px;

      .title {
        font-size: 20px;
        margin-bottom: 15px;
      }

      .title-description {
        font-size: 46px;
        line-height: 46px;
        font-weight: 100;
        margin: 30px 0;
      }

      .description {
        font-size: 22px;
        font-style: italic;
        font-weight: 100;
        line-height: 28px;
        margin-bottom: 30px;
      }

      .btn {
        width: 160px;
        height: 40px;
        line-height: 35px;
        font-size: 1.8em;
      }
    }
  }

  .slick-dotted.slick-slider {
    margin-bottom: 0;
  }
}

@media (max-width: 480px) {
  .Carousel {
    .box {
      left: 40px;

      .title {
        font-size: 20px;
        margin-bottom: 15px;
      }

      .title-description {
        font-size: 32px;
        line-height: 32px;
        font-weight: 100;
        margin: 20px 0;
      }

      .description {
        width: 80%;
        font-size: 18px;
        font-style: italic;
        font-weight: 100;
        line-height: 22px;
        margin-bottom: 30px;
      }

      .btn {
        width: 160px;
        height: 40px;
        line-height: 35px;
        font-size: 1.8em;
      }
    }
  }

  .slick-dotted.slick-slider {
    margin-bottom: 0;
  }
}

@media (max-width: 430px) {
  .Carousel {
    .box {
      left: 40px;

      .title {
        font-size: 16px;
        margin-bottom: 15px;
        margin-top: 20px;
      }

      .title-description {
        font-size: 28px;
        line-height: 28px;
        font-weight: 100;
        margin: 20px 0;
      }

      .description {
        width: 65%;
        font-size: 16px;
        font-style: italic;
        font-weight: 100;
        line-height: 22px;
        margin-bottom: 20px;
      }

      .btn {
        width: 160px;
        height: 40px;
        line-height: 35px;
        font-size: 1.8em;
      }
    }

    .slick-dots {
      bottom: 20px;
    }
  }

  .slick-dotted.slick-slider {
    margin-bottom: 0;
  }
}

@media (max-width: 360px) {
  .Carousel {
    max-height: 360px;

    video {
      max-height: 360px;
    }

    .box {
      left: 30px;

      .title {
        font-size: 16px;
        margin-bottom: 10px;
        margin-top: 0;
      }

      .title-description {
        font-size: 28px;
        line-height: 28px;
        font-weight: 100;
        margin: 15px 0;
      }

      .description {
        width: 65%;
        font-size: 16px;
        font-style: italic;
        font-weight: 100;
        line-height: 22px;
        margin-bottom: 20px;
      }

      .btn {
        width: 120px;
        height: 30px;
        line-height: 28px;
        font-size: 1.4em;
        border-width: 1px;
      }
    }

    .slick-dots {
      bottom: 20px;
      display: none !important;
    }
  }

  .slick-dotted.slick-slider {
    margin-bottom: 0;
  }
}

video {
  min-width: 100%;
  max-height: 600px;
  width: auto;
  z-index: -10000;
  overflow: hidden;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/carousel/Carousel.vue